import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2
      className="text-white uppercase mb-5 border-b border-yellow-400 pb-3"
      style={{
        fontFamily: "'BebasNeue-Book', sans-serif",
        fontSize: "clamp(24px, 2.5vw, 34px)",
        letterSpacing: "0.04em",
        lineHeight: "1.1"
      }}
    >
      {title}
    </h2>
    <div
      className="text-gray-300 space-y-4"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 300,
        fontSize: "0.97rem",
        lineHeight: "1.75",
        letterSpacing: "0.01em"
      }}
    >
      {children}
    </div>
  </section>
);

const Item = ({ num, children }) => (
  <p>
    <span className="text-yellow-400 mr-2" style={{ fontFamily: "'BebasNeue-Book', sans-serif" }}>{num}</span>
    {children}
  </p>
);

const TermosCondicoes = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />

      <PageHeader
        title="TERMOS E CONDIÇÕES"
        subtitle="Condições contratuais aplicáveis aos serviços do ULTIMATE FIT — Estúdio de Treino."
        backgroundImage=""
        overlayOpacity={1}
      />

      <article className="py-16 sm:py-20 md:py-24 bg-black" data-testid="termos-content">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">

          <p
            className="text-gray-300 mb-6"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.75"
            }}
          >
            Os presentes Termos e Condições regulam a utilização do espaço ULTIMATE FIT — Estúdio de Treino, operado por Rui F. Marques e Manuel J. Gonzalez, trabalhadores independentes, bem como a relação entre os utilizadores do espaço e os profissionais que nele exercem atividade.
          </p>
          <p
            className="text-gray-300 mb-12"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              fontSize: "0.97rem",
              lineHeight: "1.75"
            }}
          >
            A utilização das instalações e serviços implica a aceitação integral destes termos, bem como do Regulamento Interno em vigor.
          </p>

          <Section title="1 — Modelo de funcionamento">
            <Item num="1.1">
              O ULTIMATE FIT é um estúdio de treino que disponibiliza um espaço físico para a prática de exercício, onde operam profissionais de fitness independentes.
            </Item>
            <Item num="1.2">
              Os serviços de treino personalizado (Personal Training) são prestados por profissionais autónomos, que atuam de forma independente e são responsáveis pela definição de preços, condições, faturação e acompanhamento dos seus clientes.
            </Item>
            <Item num="1.3">
              O ULTIMATE FIT não intervém na relação contratual entre o cliente e o respetivo Personal Trainer, não sendo responsável pelas condições acordadas entre ambos.
            </Item>
            <Item num="1.4">
              As aulas de grupo (como Pilates, Yoga, HIIT Burn, entre outras) são organizadas diretamente no âmbito do ULTIMATE FIT.
            </Item>
            <Item num="1.5">
              O ULTIMATE FIT atua como espaço de treino e organização de atividades, não constituindo uma entidade empresarial autónoma nem assumindo a posição de prestador único de serviços de fitness.
            </Item>
          </Section>

          <Section title="2 — Pagamentos">
            <Item num="2.1">
              Os serviços de treino personalizado são pagos diretamente ao respetivo Personal Trainer, de acordo com as condições por este definidas.
            </Item>
            <Item num="2.2">
              As aulas de grupo são pagas no âmbito do ULTIMATE FIT, podendo a faturação ser efetuada por Rui F. Marques ou Manuel J. Gonzalez, enquanto trabalhadores independentes.
            </Item>
            <Item num="2.3">
              Os valores das aulas de grupo poderão ser atualizados, sendo essa alteração comunicada previamente aos clientes.
            </Item>
          </Section>

          <Section title="3 — Utilização do estúdio">
            <Item num="3.1">
              A utilização das instalações é permitida apenas durante sessões de treino ou aulas devidamente agendadas.
            </Item>
            <Item num="3.2">
              O acesso ao estúdio pressupõe o cumprimento das normas internas e o respeito pelos restantes utilizadores e profissionais.
            </Item>
            <Item num="3.3">
              O ULTIMATE FIT reserva-se o direito de recusar ou suspender o acesso ao espaço em caso de comportamento inadequado, incumprimento das regras ou falta de respeito.
            </Item>
          </Section>

          <Section title="4 — Normas de utilização">
            <Item num="4.1">
              É obrigatória a utilização de toalha durante os treinos.
            </Item>
            <Item num="4.2">
              É obrigatório o uso de calçado adequado.
            </Item>
            <Item num="4.3">
              Os equipamentos devem ser utilizados de forma responsável e higienizados após utilização.
            </Item>
            <Item num="4.4">
              Todas as normas constantes no Regulamento Interno fazem parte integrante destes Termos e Condições.
            </Item>
          </Section>

          <Section title="5 — Seguro e responsabilidade">
            <Item num="5.1">
              Cada Personal Trainer é responsável por assegurar a existência de seguro de acidentes pessoais para os seus clientes, conforme legislação aplicável.
            </Item>
            <Item num="5.2">
              No caso das aulas de grupo organizadas no âmbito do ULTIMATE FIT, são asseguradas as obrigações legais aplicáveis.
            </Item>
            <Item num="5.3">
              O ULTIMATE FIT não se responsabiliza por lesões, acidentes ou danos decorrentes da prática de exercício físico no âmbito de sessões de treino personalizado, sendo essa responsabilidade do profissional que acompanha o cliente.
            </Item>
          </Section>

          <Section title="6 — Cancelamentos e reagendamentos">
            <Item num="6.1">
              As condições de cancelamento, reagendamento e reembolso relativas ao treino personalizado são definidas exclusivamente por cada Personal Trainer.
            </Item>
            <Item num="6.2">
              No caso das aulas de grupo, os cancelamentos ou alterações deverão respeitar as condições comunicadas no momento da inscrição.
            </Item>
          </Section>

          <Section title="7 — Termo de responsabilidade">
            <p>
              Ao utilizar os serviços do ULTIMATE FIT, o cliente declara que se encontra em condições físicas adequadas para a prática de exercício físico, assumindo a responsabilidade pela sua participação.
            </p>
            <p>
              Recomenda-se a consulta prévia de um profissional de saúde antes do início da prática desportiva.
            </p>
          </Section>

          <Section title="8 — Limitação de responsabilidade">
            <Item num="8.1">
              O ULTIMATE FIT não se responsabiliza por furtos, perdas ou danos de objetos pessoais no interior das instalações.
            </Item>
            <Item num="8.2">
              O ULTIMATE FIT não é responsável por atos, omissões ou condutas dos profissionais independentes que utilizam o espaço.
            </Item>
          </Section>

          <Section title="9 — Proteção de dados">
            <p>
              O tratamento de dados pessoais é efetuado em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) e de acordo com a Política de Privacidade disponível no website.
            </p>
          </Section>

          <Section title="10 — Alterações">
            <p>
              O ULTIMATE FIT reserva-se o direito de alterar os presentes Termos e Condições sempre que necessário, sendo as alterações devidamente comunicadas através do website ou por outros meios adequados.
            </p>
          </Section>

          <Section title="11 — Lei aplicável e resolução de litígios">
            <p>
              Os presentes Termos e Condições regem-se pela legislação portuguesa.
            </p>
            <p>
              Em caso de litígio, será competente o foro da comarca de Aveiro.
            </p>
            <p>
              Nos termos da Lei n.º 144/2015, de 8 de setembro, o consumidor poderá recorrer a entidades de resolução alternativa de litígios de consumo.
            </p>
          </Section>

          <div className="pt-8 mt-12 border-t border-gray-800">
            <p
              className="text-gray-400 italic"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 300,
                fontSize: "0.9rem"
              }}
            >
              ULTIMATE FIT — Estúdio de Treino · Última atualização: 2026
            </p>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default TermosCondicoes;
